import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetReferalListBo } from './referral.modal';
@Injectable({
  providedIn: 'root'
})
export class ReferralServices extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent
  ) {
    super()
  }
  public outputValues(RState: GetReferalListBo): void {
    this.getReferralList(RState).subscribe(x => super.next(x));
  }
  getReferralList(RState?: GetReferalListBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Referral/GetReferralList", RState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count'],
          }
      )).pipe(map((e: any) => {
        e?.result?.forEach((ele) => {
        })
        return e;
      }))
  }
  GetAllClientDropDown(url): Observable<any> {
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetUserDropDown(): Observable<any> {
    let url = "api/User/GetUserDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  SaveReferralFunction(data: any): Observable<any> {
    let url = "api/Referral/SaveReferral";
    return this.http.post(url, data, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  DeleteReferral(paramsData: URLSearchParams) {
    let url = "api/Referral/deleteReferral?"
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetLocationDropDown(): Observable<any> {

    let url = "api/Location/GetLocationDropDown";

    return this.http.get<any>(url, { observe: 'response' }).pipe(

      map(data => data.body),

      catchError(this.errorService.handleError)

    )

  }
}
